import { computed, effect, inject, Injectable, signal } from "@angular/core";
import { rxResource } from '@angular/core/rxjs-interop';
import { CountryViewModel, QuizService } from "@app/shared/rest-api";
import { CreateJeopardyGameGQL, CreateJeopardyGameMutation } from "./data.service.generated";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AddJeopardyGameInput } from "@app/shared/graphql/types";

@Injectable({
  providedIn: "root",
})
export class DataService {
  public readonly app = signal('challengeu');
  public readonly language = signal("en-GB");

  public readonly metadata = rxResource({
    request: () => ({ language: this.language() }),
    loader: ({request}) => this.quizService.apiQuizMetadataGet(request.language),
  }).value;

  public readonly countries = computed(() => this.metadata()?.countries ?? []);

  private createJeopardyGameMutation = inject(CreateJeopardyGameGQL);

  constructor(
    private quizService: QuizService,
  ) {
    effect(() => {
      console.log('language changed', this.language());
    });
  }

  public createJeopardyGame(input: AddJeopardyGameInput): Observable<CreateJeopardyGameMutation['createJeopardyGame']> {
    return this.createJeopardyGameMutation.mutate({ input }).pipe(map(result => result.data?.createJeopardyGame));
  }

  public searchCountries(searchText: string): CountryViewModel[] {
    return this.countries().filter(country => country.value.toLowerCase().startsWith(searchText.toLowerCase()));
  }
}
